import React from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  LinearProgress,
  Avatar,
} from "@mui/material";
import {
  Person as PersonIcon,
  DirectionsCar as DirectionsCarIcon,
  Place as PlaceIcon,
  LocalShipping as LocalShippingIcon,
  LocationOn as LocationOnIcon,
} from "@mui/icons-material";

const TrackerHeader = ({ data }) => {
  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          Delivery Route Tracker
        </Typography>
      </Box>

      {/* Driver Info */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3} sx={{ display: "flex" }}>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              display: "flex",
              alignItems: "center",
              gap: 2,
              height: "100%",
              width: "100%",
            }}
          >
            <Avatar sx={{ bgcolor: "primary.light", color: "primary.main" }}>
              <PersonIcon />
            </Avatar>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Driver
              </Typography>
              <Typography variant="body1" fontWeight="medium">
                {data.driverName}
              </Typography>
              {data.driverPhone && data.driverPhone !== "N/A" && (
                <Typography variant="caption" color="text.secondary">
                  {data.driverPhone}
                </Typography>
              )}
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6} md={3} sx={{ display: "flex" }}>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              display: "flex",
              alignItems: "center",
              gap: 2,
              height: "100%",
              width: "100%",
            }}
          >
            <Avatar
              sx={{ bgcolor: "secondary.light", color: "secondary.main" }}
            >
              <DirectionsCarIcon />
            </Avatar>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Vehicle
              </Typography>
              <Typography variant="body1" fontWeight="medium">
                {data.vehicleId}
              </Typography>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6} md={3} sx={{ display: "flex" }}>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              display: "flex",
              alignItems: "center",
              gap: 2,
              height: "100%",
              width: "100%",
            }}
          >
            <Avatar sx={{ bgcolor: "success.light", color: "success.main" }}>
              <PlaceIcon />
            </Avatar>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Stops Completed
              </Typography>
              <Typography variant="body1" fontWeight="medium">
                {data.completedStops} / {data.totalStops} stops
              </Typography>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6} md={3} sx={{ display: "flex" }}>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              display: "flex",
              alignItems: "center",
              gap: 2,
              height: "100%",
              width: "100%",
            }}
          >
            <Avatar sx={{ bgcolor: "warning.light", color: "warning.main" }}>
              <LocalShippingIcon />
            </Avatar>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Orders Delivered
              </Typography>
              <Typography variant="body1" fontWeight="medium">
                {data.deliveredOrders} / {data.totalOrders} orders
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Progress Bar */}
      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Typography
            variant="body2"
            fontWeight="medium"
            color="text.secondary"
          >
            Route Progress
          </Typography>
          <Typography variant="body2" fontWeight="medium">
            {data.progressPercent}%
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={data.progressPercent}
          sx={{
            height: 8,
            borderRadius: 4,
            backgroundColor: "grey.200",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "success.main",
              borderRadius: 4,
            },
          }}
        />
      </Box>

      {/* Current Stop Info */}
      {data.currentStopName && (
        <Paper
          variant="outlined"
          sx={{
            p: 2,
            mt: 2,
            backgroundColor: "primary.light",
            borderColor: "primary.main",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <LocationOnIcon color="primary" />
            <Typography
              variant="body1"
              fontWeight="medium"
              color="primary.main"
            >
              Next Stop {data.currentStop} of {data.totalStops}
            </Typography>
          </Box>
          <Typography variant="body2" color="primary.dark">
            {data.currentStopName}
          </Typography>
        </Paper>
      )}
    </Paper>
  );
};

export default TrackerHeader;
